export const vehicles = [
  {
    id: 1,
    name: 'Tesla Model 3',
    price: 15000,
    image: '/cars/tesla-model-3.jpg',
    transmission: 'Automatic',
    fuelType: 'Electric',
    type: 'car',
    brand: 'Tesla',
    model: 'Model 3',
    ratings: {
      average: 4.8,
      count: 124
    },
    specifications: {
      range: '350 km',
      power: '283 hp',
      seatingCapacity: 5
    },
    features: [
      'Autopilot',
      'Premium Sound',
      'Heated Seats',
      'Navigation'
    ],
    location: 'Dhaka, Bangladesh',
    insurance: {
      coverage: 'Comprehensive',
      included: true
    }
  },
  {
    id: "2",
    name: "Vehicle 2",
    price: 15000,
    image: '/cars/tesla-model-3.jpg',
    transmission: 'Automatic',
    fuelType: 'Electric',
    type: 'car',
    brand: 'Tesla',
    model: 'Model 3',
    ratings: {
      average: 4.8,
      count: 124
    },
    specifications: {
      range: '350 km',
      power: '283 hp',
      seatingCapacity: 5
    },
    features: [
      'Autopilot',
      'Premium Sound',
      'Heated Seats',
      'Navigation'
    ],
    location: 'Dhaka, Bangladesh',
    insurance: {
      coverage: 'Comprehensive',
      included: true
    }
  },
  // ... add more vehicles with similar structure
];

// Export a function to get unique vehicles
export const getUniqueVehicles = () => {
  return [...new Map(vehicles.map(v => [v.id, v])).values()];
}; 